class ProductQuantityInput extends HTMLElement {
  constructor() {
  super();

  // Get data we need for operations

  this.input = this.querySelector('#required-metres-squared');
  this.price = this.dataset.price;
  this.packSize = Number(this.dataset.packSize);

  this.minQty = this.dataset.minQty;
  this.evenPacks = this.dataset.evenPacks;


  this.packPrice = this.dataset.packPrice;
  this.wasteageFee = this.querySelector('#wastage-fee');
  this.totalPrice = this.querySelector('#total-price');
  this.tooltip = this.querySelector('#product-tooltip');
  this.rrpSavings = this.querySelector('#rrp-savings');
  this.productBasketAreaCoverageContainer = this.querySelector('.product-basket-area-coverage-container');
  this.requiredWidthInput = this.querySelector('#required-width');
  this.requiredLengthInput = this.querySelector('#required-length');
  this.submitButton = document.querySelector('product-form-advance [data-action="add-to-cart"]');
  this.toggleCalcHelperCheckBox = document.querySelector('#toggle-calc-helper');

  this.type = this.dataset.type;
  this.rollWidth = this.dataset.productRollWidth;
  this.boardSize = this.dataset.boardSize;
  this.altMetreInput = this.querySelector('#required-metres-squared-alternative');
  this.width = this.dataset.width;
  this.length = this.dataset.length;
  this.tilesPerPack = this.dataset.tilesPerPack;
  this.minQtyNotice = this.querySelector('#product-minimum-quantity-notice');

  this.wasteageFee !== null ? this.wasteageFee.addEventListener('change', () => this.wasteageCheck(this.wasteageFee.checked)) : null;
  this.toggleCalcHelperCheckBox !== null ? this.toggleCalcHelperCheckBox.addEventListener('change', () => this.toggleShowCalcHelper(this.toggleCalcHelperCheckBox.checked)) : null;
  this.input !== null ? this.input.addEventListener('input', (evt) => this.inputChange(evt.target.value)) : null;
  this.requiredWidthInput !== null ? this.requiredWidthInput.addEventListener('input', (evt) => this.dimensionChange()) : null;
  this.requiredLengthInput !== null ? this.requiredLengthInput.addEventListener('input', (evt) => this.dimensionChange()) : null;
  this.altMetreInput !== null ? this.altMetreInput.addEventListener('input', (evt) => this.altMetreInputChange(evt.target.value)) : null;
}


// This function is called when the main
// text input is changed

async inputChange(val) {

  // Check if there is an accessory restriction, and if so,
  // disable the Add To Cart button

    // updated this 13 oct
  // if ( this.submitButton.dataset.accessoryRestriction == "true" ) {
  // 	this.submitButton.disabled = true;
  // 	return;
  // }
      if ( this.submitButton.dataset.accessoryRestriction == "true" ) {
    this.submitButton.disabled = true;
    return;
  }
//       else {
  // 	this.submitButton.disabled = false;
//         return;
  // }

  const price = Number(this.price);
  const quantity = await this.checkWasteage(Number(val));
  const packSize = this.packSize;

  // Check the product type and use the appropriate
  // calculator

  if ( this.type === "Pack" ) {
    const packPrice = Number(this.packPrice);
    this.anyPackCalc(packPrice, quantity, packSize);
  }
  else if ( this.type === "Roll" ) {
    this.rollCalc(price, quantity);
  }
  else if ( this.type === "Box" ) {
    this.boxCalc(price, quantity);
  }
  else if ( this.type === "Tile" ) {
    this.tileCalc(price, quantity);
  }
  else if ( this.type === "Board" ) {
    const boardPrice = Number(this.price) / 100;
    this.boardCalc(boardPrice, quantity);
  }
  else {
    this.nonPackCalc(price, quantity);
  }
}

// Some products/product types may have a second text input
// on the product page. If so, this function is called when
// the input is changed

async altMetreInputChange(val) {

  // Check if there is an accessory restriction, and if so,
  // disable the Add To Cart button

  if ( this.submitButton.dataset.accessoryRestriction == "true" ) {
    this.submitButton.disabled = true;
    return;
  }

  const price = Number(this.price);
  const quantity = await this.checkWasteage(Number(val));

  // Check the product type, and use the appropriate calculator

  if ( this.type === "Tile" ) {
    this.tileMetreCalc(price, quantity);
  }
  else if ( this.type === "Pack" ) {
    const packPrice = Number(this.packPrice);
    const packSize = this.packSize;
    this.altPackCalc(packPrice, quantity, packSize);
  }
}

// HERE ARE THE THREE PACK CALCULATORS

// This is the main pack calculator for the main
// text input

async anyPackCalc(price, quantity, packSize) {
  const evenPacks = this.evenPacks === "true" ? true : false;
  let total;
  let packs;
  let metresInPack;
  let roundedQuantity;
  if ( Number.isInteger(quantity / packSize) ) {
    // If the number of square metres inputted
    // fits into the number of metres required
    // to make up a Pack

    packs = Number((quantity / packSize).toFixed(0));
    metresInPack = quantity.toFixed(2);
    total = price * packs;
  }
  else {
    // Else, we need to round up the number of
    // square metres so that it fits into the
    // pack size.

    roundedQuantity = await this.roundUp(quantity, packSize);
    packs = Number((roundedQuantity / packSize).toFixed(0));
    metresInPack = roundedQuantity.toFixed(2);
    total = price * packs;
  }

  const evenPacksOrdered = this.isEven(packs);
  if ( quantity === 1 ) {
    // If only 1 square metre is inputted
    // this.packOne(Number(this.price));

    const formattedTotal = total.toFixed(2);
    this.totalPrice.innerHTML = formattedTotal;
    this.tooltip.innerHTML = `This equals ${packs} packs (${metresInPack}m<sup>2</sup>)`;
    this.setAttribute("data-units", packs);
    this.altMetreInput.value = packs;
  }
  // else if ( packs === 1 ) {
  // 	const formattedTotal = total.toFixed(2);
  // 	this.totalPrice.innerHTML = formattedTotal;
  // 	this.tooltip.innerHTML = `This equals ${packs} packs (${metresInPack}m<sup>2</sup>)`;
  // 	this.setAttribute("data-units", packs);
  // 	this.altMetreInput.value = packs;

  // 	this.minQtyNotice.style.display = "none";
  // }
  else if ( evenPacks === true && evenPacksOrdered === false ) {
    // If this product requires that the number of packs
    // ordered is even

    this.evenPackCalc(packs, packSize, price);
  }
  else {
    // Else, print the total on the frontend

    const formattedTotal = total.toFixed(2);
    this.totalPrice.innerHTML = formattedTotal;
    this.tooltip.innerHTML = `This equals ${packs} packs (${metresInPack}m<sup>2</sup>)`;
    this.setAttribute("data-units", packs);
    this.altMetreInput.value = packs;
  }

  // Disable ATC button if the minimum
  // quantity is not met

  /* if ( quantity !== 1 ) {
    this.checkDisabled(packs);
  }
  else {
    this.submitButton.disabled = false;
  } */

  this.checkDisabled(packs);
}


// We use this calculator if the product can only
// be ordered in even packs

async evenPackCalc(packs, packSize, price) {

  // Increase the pack number by 1, so that it's
  // now an even number, then calculate the total

  const evenNumberPacks = Number(packs) + 1;
  const metresInPack = (packSize * evenNumberPacks);
  const total = price * evenNumberPacks;
  const formattedTotal = total.toFixed(2);
  this.totalPrice.innerHTML = formattedTotal;
  this.tooltip.innerHTML = `This equals ${evenNumberPacks} packs (${metresInPack.toFixed(2)}m<sup>2</sup>)`;
  this.setAttribute("data-units", evenNumberPacks);

  this.altMetreInput.value = evenNumberPacks;
  this.checkDisabled(evenNumberPacks);
}

// This calculator is used if the secondary text input
// is changed, and the product is a pack

async altPackCalc(packPrice, quantity, packSize) {
  const evenPacks = this.evenPacks === "true" ? true : false;
  const evenPacksOrdered = this.isEven(quantity);

  // if ( quantity === 1 ) {
  // 	const total = packPrice * quantity;
  // 	const metresInPack = packSize * quantity;
  // 	const formattedTotal = total.toFixed(2);
  // 	this.totalPrice.innerHTML = formattedTotal;
  // 	this.tooltip.innerHTML = `This equals ${quantity} packs (${metresInPack.toFixed(2)}m<sup>2</sup>)`;
  // 	this.setAttribute("data-units", quantity);

  // 	this.input.value = metresInPack.toFixed(2);
  // 	this.submitButton.disabled = false;

  // 	this.minQtyNotice.style.display = "none";
  // }
  // else if

  if ( evenPacks === true && evenPacksOrdered === false ) {
    // Even packs only

    const quantityPlusOne = quantity + 1;
    const total = packPrice * quantityPlusOne;
    const metresInPack = packSize * quantityPlusOne;
    const formattedTotal = total.toFixed(2);
    this.totalPrice.innerHTML = formattedTotal;
    this.tooltip.innerHTML = `This equals ${quantityPlusOne} packs (${metresInPack.toFixed(2)}m<sup>2</sup>)`;
    this.setAttribute("data-units", quantityPlusOne);

    this.input.value = metresInPack.toFixed(2);
    this.checkDisabled(quantityPlusOne);
  }
  else {
    // Even or odd packs

    const total = packPrice * quantity;
    const metresInPack = packSize * quantity;
    const formattedTotal = total.toFixed(2);
    this.totalPrice.innerHTML = formattedTotal;
    this.tooltip.innerHTML = `This equals ${quantity} packs (${metresInPack.toFixed(2)}m<sup>2</sup>)`;
    this.setAttribute("data-units", quantity);

    this.input.value = metresInPack.toFixed(2);
    this.checkDisabled(quantity);
  }
}

// This calculator is used if 1 Square Metre is ordered
// and the product type is a pack

async packOne(price) {

  const total = price/100;
  this.totalPrice.innerHTML = total;
  this.submitButton.disabled = false;
  this.setAttribute("data-units", "1sqm");
}


// If "Cuts & Wasteage" tickbox is clicked,
// this function is called

async wasteageCheck(val) {
  const quantity = this.querySelector('#required-metres-squared').value;
  this.inputChange(quantity);
}

async toggleShowCalcHelper(val) {
  this.productBasketAreaCoverageContainer.classList.toggle('show-calc-helper');
  // this.input.disabled = val;
  /* await this.inputChange(0);
  this.minQtyNotice.style.display = "none";
  this.tooltip.innerHTML = ""; */
}

async dimensionChange() {
  const width = this.requiredWidthInput.value;
  const length = this.requiredLengthInput.value;

  const value = (width * length).toFixed(2);
  this.input.value = value;
  this.inputChange(value);
  // this.requiredMetresSquaredValueInput
  // this.inputChange(0);
}


// This calculator is used if the product type is a roll

async rollCalc(price, quantity) {
  const rollWidth = Number(this.rollWidth);
  const roundedQuantity = Math.ceil(quantity);
  const rollSquareMetres = roundedQuantity * rollWidth;
  const total = (roundedQuantity * price)/100;
  const formattedTotal = total.toFixed(2);
  this.totalPrice.innerHTML = formattedTotal;
  this.tooltip.innerHTML = `You require ${roundedQuantity}m length (${rollSquareMetres}m<sup>2</sup>)`;
  this.setAttribute("data-units", roundedQuantity);
  this.checkDisabled(roundedQuantity);
}

// This calculator is used if the product type
// is a Box

async boxCalc(price, quantity) {
  const minQty = Number(this.minQty);
  const roundedQuantity = Math.ceil(quantity);

  if ( roundedQuantity >= minQty ) {
    const total = (roundedQuantity * price)/100;
    const formattedTotal = total.toFixed(2);
    this.totalPrice.innerHTML = formattedTotal;
    this.tooltip.innerHTML = `You require ${roundedQuantity} boxes`;
    this.setAttribute("data-units", roundedQuantity);
  }
  this.checkDisabled(roundedQuantity);
}

// This calculator is used if the product type is a Board

async boardCalc(price, quantity) {
  const boardSize = Number(this.boardSize);
  const requiredBoards = Math.ceil(quantity / boardSize);
  const metresInRequiredBoards = requiredBoards * boardSize;
  const total = price * requiredBoards;
  const formattedTotal = total.toFixed(2);
  this.totalPrice.innerHTML = formattedTotal;
  this.tooltip.innerHTML = `You require ${requiredBoards} boards (${metresInRequiredBoards.toFixed(2)}m<sup>2</sup>)`;
  this.setAttribute("data-units", requiredBoards);
  this.checkDisabled(requiredBoards);
}

// If the product type is a Tile
// and the customer wants to order
// by the tile (which is then turned into Packs)

async tileCalc(price, quantity) {
  const minQty = Number(this.minQty);
  const roundedQuantity = await this.tilesInPacks(quantity);
  const tilesPerPack = this.tilesPerPack;
  const tilesInPacks = roundedQuantity * tilesPerPack;

  if ( quantity === 1 ) {
    const total = price/100;
    const formattedTotal = total.toFixed(2);
    this.totalPrice.innerHTML = formattedTotal;
    this.setAttribute("data-units", 1);

    const squareMetreTile = await this.calculateTileUnits();
    const metresInTile = squareMetreTile;
    this.altMetreInput.value = metresInTile.toFixed(2);
    this.tooltip.innerHTML = `You require 1 tile (${metresInTile.toFixed(2)}m<sup>2</sup>)`;
  }
  else if ( roundedQuantity >= minQty ) {
    const total = (tilesInPacks * price)/100;
    const formattedTotal = total.toFixed(2);
    this.totalPrice.innerHTML = formattedTotal;
    this.setAttribute("data-units", tilesInPacks);

    const squareMetreTile = await this.calculateTileUnits();
    const metresInTile = tilesInPacks * squareMetreTile;
    this.altMetreInput.value = metresInTile.toFixed(2);
    this.tooltip.innerHTML = `You require ${roundedQuantity} pack${roundedQuantity === 1 ? '' : 's'}, which contain${roundedQuantity === 1 ? 's' : ''} ${tilesInPacks} tiles (${metresInTile.toFixed(2)}m<sup>2</sup>)`;
  }

  this.checkDisabled(roundedQuantity);
}

// If the product type is a Tile
// and the customer wants to order
// by the square metre

async tileMetreCalc(price, quantity) {
  const minQty = Number(this.minQty);

  if ( quantity >= minQty ) {
    // Use width and length metafields to get dimensions

    // Check if values are in (mm), (cm) or (m)

    // Turn them into metres

    // Round up based on number of square metres
    // the user has inputted so that we get to the
    // nearest pack

    const squareMetreTile = await this.calculateTileUnits();
    const remainder = await this.checkRemainder(quantity, squareMetreTile);
    let rounded;

    if ( remainder === 0 ) {
      rounded = quantity / squareMetreTile;
    }
    else if ( quantity < squareMetreTile ) {
      rounded = 1;
    }
    else {
      rounded = quantity / squareMetreTile;
      rounded = Math.ceil(rounded);
    }

    const tilesPerPack = this.tilesPerPack;
    const roundedTileNumber = await this.roundUp(rounded, tilesPerPack);
    const packs = roundedTileNumber / tilesPerPack;

    this.input.value = roundedTileNumber;

    const metresInRequiredTiles = roundedTileNumber * squareMetreTile;
    const total = (price * roundedTileNumber)/100;
    const formattedTotal = total.toFixed(2);
    this.totalPrice.innerHTML = formattedTotal;
    this.tooltip.innerHTML = `You require ${packs} pack${packs === 1 ? '' : 's'}, which contain${packs === 1 ? 's' : ''} ${roundedTileNumber} tiles (${metresInRequiredTiles.toFixed(2)}m<sup>2</sup>)`;
    this.setAttribute("data-units", roundedTileNumber);
  }

  this.checkDisabled(quantity);
}

async calculateTileUnits() {
  // Check whether the units of the tiles are mm, cm, or m

  const widthUnits = this.width.includes("mm") ? "mm" : this.width.includes("cm") ? "cm" : "m";
  const lengthUnits = this.width.includes("mm") ? "mm" : this.width.includes("cm") ? "cm" : "m";

  let adjustedWidth;
  let adjustedLength;

  if ( widthUnits === "mm" ) {
    adjustedWidth = Number(this.width.replace(widthUnits, "")) / 1000;
  }
  else if ( widthUnits === "cm" ) {
    adjustedWidth = Number(this.width.replace(widthUnits, "")) / 100;
  }
  else {
    adjustedWidth = Number(this.width.replace(widthUnits, ""))
  }

  if ( lengthUnits === "mm" ) {
    adjustedLength = Number(this.length.replace(lengthUnits, "")) / 1000;
  }
  else if ( widthUnits === "cm" ) {
    adjustedLength = Number(this.length.replace(lengthUnits, "")) / 100;
  }
  else {
    adjustedLength = Number(this.length.replace(lengthUnits, ""))
  }

  const squareMetreTile = adjustedLength * adjustedWidth;

  return squareMetreTile;
}

async tilesInPacks(quantity) {
  // Calculate how many tiles go in a pack

  const tilesPerPack = this.tilesPerPack;
  const remainder = await this.checkRemainder(quantity, tilesPerPack);
  let packs;

  if ( remainder === 0 ) {
    packs = quantity / tilesPerPack;
    return packs;
  }
  else {
    const roundedUp = await this.roundUp(quantity, tilesPerPack);
    const packs = await roundedUp / tilesPerPack;
    return packs;
  }
}


// This calculator is used for all remaining
// product types

async nonPackCalc(price, quantity) {
  const minQty = Number(this.minQty);
  const roundedQuantity = Math.ceil(quantity);

  if ( roundedQuantity >= minQty ) {
    if (this.minQtyNotice) {
      this.minQtyNotice.style.display = "none";
    }
  }
  else {
    if (this.minQtyNotice) {
      this.minQtyNotice.removeAttribute("style");
    }
  }

  const total = (price * roundedQuantity)/100;
  const formattedTotal = total.toFixed(2);
  this.totalPrice.innerHTML = formattedTotal;
  this.tooltip.innerHTML = `You require ${roundedQuantity}m length (${roundedQuantity}m<sup>2</sup>)`;
  this.setAttribute("data-units", roundedQuantity);

  this.checkDisabled(quantity);
}


// EXTRA FUNCTIONS

roundUp(qty, pack) {
  // Round number of square metres up
  // so that it fits into the pack size

  return Math.ceil(qty/pack)*pack;
}

isEven(n) {
  // Check if number is even

  return n % 2 == 0;
}

checkWasteage(qty) {
  // If wasteage is ticked, add 10% to
  // the desired quantity
  const val = this.wasteageFee ? this.wasteageFee.checked : false;
  if ( val === true ) {
    const newQty = qty + (qty * 0.1);
    return newQty;
  }
  else {
    return qty;
  }
}

checkRemainder(quantity, squareMetreTile) {
  // Check remainder of quantity desired
  // vs number of square metres in a tile

  return (quantity % squareMetreTile);
}


checkDisabled(quantity) {
  // Check if minimum quantity has been ordered, and if not,
  // disable the ATC button

  if ( quantity < Number(this.minQty) ) {
    this.submitButton.disabled = true;
    if(this.minQtyNotice) {
      this.minQtyNotice.removeAttribute("style");
    }
  }
  else {
    this.submitButton.disabled = false;
    if ( this.minQtyNotice && this.type === "Pack" ) {
      this.minQtyNotice.style.display = "none";
    }
  }
}
}

customElements.define('product-quantity-input', ProductQuantityInput);
